import { render, staticRenderFns } from "./ClientMeetings.vue?vue&type=template&id=38d0072f&scoped=true&"
import script from "./ClientMeetings.vue?vue&type=script&lang=js&"
export * from "./ClientMeetings.vue?vue&type=script&lang=js&"
import style0 from "./ClientMeetings.vue?vue&type=style&index=0&id=38d0072f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d0072f",
  null
  
)

export default component.exports